import {Component, Input} from '@angular/core';
import {BaseSwiperCardComponent} from '../base-swiper-card.component';
import {SwiperInfoItem} from '../models/swiper-item.models';

@Component({
  selector: 'app-swiper-card-info',
  templateUrl: './swiper-card-info.component.html',
  styleUrls: ['../swiper.scss']
})
export class SwiperCardInfoComponent extends BaseSwiperCardComponent {
  @Input() swiperInfoItems: Array<SwiperInfoItem>;
}
